/* src/app/private/components/enrollment/bulk-delete-enrollment/bulk-delete-enrollment.component.scss */
/*# sourceMappingURL=bulk-delete-enrollment.component.css.map */
